module.exports = __webpack_public_path__ + "img/mask-group-1.17850472.png";